import { popupStore } from '@pascal/pascal-core/shared/core/store';
import { gameLiveConnection } from '../services';
import { RoutePaths } from '../enums';

class LiveConnection {
  isConnected = false;

  handleSocketInit() {
    const pathname = window.location.pathname;
    if (
      pathname === RoutePaths.game ||
      pathname === RoutePaths.terminal ||
      pathname === RoutePaths.stream
    ) {
      gameLiveConnection
        ?.init()
        .then(() => {
          this.isConnected = true;
          this.connectionInitCallback();
        })
        .catch(() => popupStore.onConnectionError(true));
    }
  }

  restartGameConnection() {
    return new Promise((res) => {
      gameLiveConnection.stop().then(() => {
        gameLiveConnection.init().then(() => {
          this.connectionInitCallback();
          res();
        });
      });
    });
  }

  connectionInitCallback(isFirstInit) {
    if (this.isConnected) {
      gameLiveConnection.sendGameGetInitialState(isFirstInit).then(() => {});
    }
  }
}

export const liveConnection = new LiveConnection();
